import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Stack } from '@monorepo/nova-ui';
import { ProgramCategory, ProgressStep } from '@monorepo/types';
import {
  NodeWrapper,
  StepContainer,
  StepLabelContainer,
} from '../styled/step-containers.styled';
import { StepNode } from '../styled/step-node.styled';
import { NodeState } from '../utils/node-styling.utils';
import { getStepLabel } from '../utils/step-labels.utils';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TFunction = any;

interface ProgressNodeProps {
  step: ProgressStep;
  index: number;
  isFirst: boolean;
  isLast: boolean;
  nodeState: NodeState;
  t: TFunction;
  totalNodes?: number;
  stepSpacing: number;
}

export const ProgressNode: FC<ProgressNodeProps> = ({
  step,
  index,
  isFirst,
  isLast,
  nodeState,
  t,
  totalNodes = 1,
  stepSpacing,
}) => {
  const renderIcon = () => {
    // Error state: show X icon for active step
    if (nodeState.hasError && nodeState.active) {
      return <SystemIcon iconName="X" />;
    }
    // First step always gets Trophy icon
    if (index === 0) {
      return <SystemIcon iconName="Trophy" />;
    }
    // For other steps, use specific icons based on category
    if (step.category === ProgramCategory.Evaluation) {
      return <SystemIcon iconName="Trophy2" />;
    } else if (step.category === ProgramCategory.Funded) {
      return <SystemIcon iconName="Confetti" />;
    } else if (step.category === ProgramCategory.ScaleUp) {
      return <SystemIcon iconName="ChartPolar" />;
    }
    // Fallback to step number
    return index + 1;
  };

  return (
    <StepContainer
      isFirst={isFirst}
      isLast={isLast}
      stepIndex={index}
      stepSpacing={stepSpacing}
    >
      {/* Step Node */}
      <NodeWrapper data-step-node data-step-index={index}>
        <StepNode
          ownerState={nodeState}
          nodeIndex={index}
          totalNodes={totalNodes}
        >
          {renderIcon()}
        </StepNode>
      </NodeWrapper>

      {/* Step Label */}
      <StepLabelContainer>
        <Stack direction="column" alignItems="center" spacing={0.5}>
          <Typography
            variant="caption"
            display="block"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
              fontSize: theme.typography.pxToRem(12),
              fontWeight: theme.typography.fontWeightRegular,
            })}
          >
            ${step.buyingPower.toLocaleString()}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
              fontSize: theme.typography.pxToRem(12),
              fontWeight: theme.typography.fontWeightMedium,
            })}
          >
            {getStepLabel(step, t)}
          </Typography>
        </Stack>
      </StepLabelContainer>
    </StepContainer>
  );
};
